const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-green-400"></div>
  </div>
  )
}

export default LoadingSpinner
